<template>
  <div
      class="background"
  >
    <div
        class="modal"
        :style="size"
    >
      <slot/>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'Modal',

  props: {
    height: Number,
    width: Number,
  },

  setup(props) {
    const size = computed(() => ({
      height: `${props.height}px`,
      width: `${props.width}px`,
    }));

    return {
      size,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';

  .background {
    background-color: rgba(0, 0, 0, .6);
    display: flex;
    height: 100vh;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100vw;
    z-index: 100;

    .modal {
      background-color: $white;
      border-radius: 20px;
      display: flex;
      height: auto;
      max-height: inherit;
      overflow: auto;
      padding: 20px;
      position: relative;
    }
  }
</style>
